import { render, staticRenderFns } from "./Itinerary.vue?vue&type=template&id=198a6a57&scoped=true&"
import script from "./Itinerary.vue?vue&type=script&lang=js&"
export * from "./Itinerary.vue?vue&type=script&lang=js&"
import style0 from "./Itinerary.vue?vue&type=style&index=0&id=198a6a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a6a57",
  null
  
)

export default component.exports